import { render, staticRenderFns } from "./BatchProposalViewer.vue?vue&type=template&id=076e3228&"
import script from "./BatchProposalViewer.vue?vue&type=script&lang=js&"
export * from "./BatchProposalViewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports